export enum ANALIZE_STATUS {
    ANALYZING = 'analyzing',
    ANALYZED = 'analyzed',
    ERROR = 'error',
}
